import { render, staticRenderFns } from "./fullLayout.vue?vue&type=template&id=86d60884&scoped=true&"
import script from "./fullLayout.vue?vue&type=script&lang=js&"
export * from "./fullLayout.vue?vue&type=script&lang=js&"
import style0 from "./fullLayout.vue?vue&type=style&index=0&id=86d60884&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86d60884",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/daniel/work/jiangxi/fed-sd-visual-web-static/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('86d60884')) {
      api.createRecord('86d60884', component.options)
    } else {
      api.reload('86d60884', component.options)
    }
    module.hot.accept("./fullLayout.vue?vue&type=template&id=86d60884&scoped=true&", function () {
      api.rerender('86d60884', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layout/fullLayout.vue"
export default component.exports